import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nullNa',
    standalone: true
})
export class NullNaPipe implements PipeTransform {
    transform(value: any): any {
        return value === null || value === undefined || value === '' ? 'N/A' : value;
    }
}
